var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabResults = function SvgLabResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    fillRule: "evenodd",
    d: "M7.5 3.667a.833.833 0 1 1 0 1.666h-.667V14.5a2.333 2.333 0 1 1-4.666 0V5.333H1.5a.833.833 0 1 1 0-1.666zM3.833 14.5a.667.667 0 0 0 1.334 0V5.333H3.833zM16.5 7.667a.833.833 0 1 1 0 1.666h-.667v1.026c0 .531.195 1.043.548 1.44l1.763 1.983c1.05 1.182.211 3.05-1.37 3.051h-6.547c-1.582 0-2.421-1.868-1.37-3.05l1.762-1.984c.353-.397.548-.909.548-1.44V9.333H10.5a.833.833 0 1 1 0-1.666zm-3.667 1.666v1.026c0 .94-.344 1.846-.968 2.547l-1.763 1.984a.167.167 0 0 0 .125.277h6.546c.144 0 .22-.17.125-.277l-1.763-1.984a3.83 3.83 0 0 1-.968-2.547V9.333z",
    clipRule: "evenodd"
  })));
};
export default SvgLabResults;